var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snotifyToast__buttons"},_vm._l((_vm.buttons),function(button,index){return _c('button',{key:index,class:[{'snotifyToast__buttons--bold': button.bold}, button.class],attrs:{"type":"button"},on:{"click":function($event){button.action && button.action(_vm.id, _vm.value)}}},[_vm._v(" "+_vm._s(button.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }